import { axiosInstance } from "@/lib/api/client";
import { TranslatableEnum } from "@rumble-it/common-lib/types/models/TranslatableEnum.interface";

export const getReplacementVehicleTypes = async () =>
  axiosInstance
    .get<TranslatableEnum[]>(`/dossiers/replacement-vehicle-type`)
    .then((response) => response.data);
